import { createFileRoute } from '@tanstack/react-router';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { NavBar } from '@/components/astro/new-design-25/ui/NavBar';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/refund-policy')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Listening | Refund Policy',
        description:
          "Explore Listening's Refund Policy to learn about eligibility and procedures for obtaining a refund. We are committed to transparency and customer satisfaction.",
      }),
    ],
  }),
  component: () => (
    <>
      <NavBar />

      <section className='mx-auto max-w-[1296px] px-3 pt-[40px] text-[14px] sm:px-5 md:px-[140px]'>
        <h1 className='mt-5 mb-3 text-[2.375rem] leading-[1.15]'>
          Listening Refund Policy
        </h1>
        <div>
          <div className='pb-3'>
            <h2 className='mb-3 text-[14px] leading-[26px] font-bold'>
              Refund Guidelines:
            </h2>
            <ul className='list-disc pl-10'>
              <li>
                The 30-day refund period commences from the last 30 days of your
                most recent payment.
              </li>
              <li>
                To qualify for a refund, you must request it within the last 30
                days of your subscription period.
              </li>
              <li>
                Refunds are applicable for both the initial subscription and
                subsequent renewals within the last 30 days of the payment
                cycle.
              </li>
            </ul>
          </div>

          <div className='pb-3'>
            <h2 className='mb-3 text-[14px] leading-[26px] font-bold'>
              How to Request a Refund:
            </h2>
            <ul className='list-decimal pl-10'>
              <li>
                Please visit{' '}
                <a
                  className='text-azure-455 underline'
                  href='https://help.listening.com/'
                >
                  help.listening.com
                </a>
              </li>
              <li>
                Ensure that refund requests are submitted within the 30-day
                period for consideration.
              </li>
            </ul>
          </div>

          <div className='pb-3'>
            <h2 className='mb-3 text-[14px] leading-[26px] font-bold'>
              Refund Process:
            </h2>
            <ul className='list-decimal pl-10'>
              <li>
                Once we receive your request, our support team will review it
                promptly.
              </li>
              <li>
                If your request meets eligibility criteria, we'll process the
                refund within 5-7 business days.
              </li>
              <li>
                Refunds will be issued to the original payment method used
                during the subscription.
              </li>
            </ul>
          </div>

          <div className='pb-3'>
            <h2 className='mb-3 text-[14px] leading-[26px] font-bold'>
              Exceptions:
            </h2>
            <ul className='list-disc pl-10'>
              <li>
                Refund requests made after the 30-day period will not be
                approved.
              </li>
              <li>
                Violations of our terms of service may result in the forfeiture
                of refund eligibility.
              </li>
              <li>
                In any case that the user signed up duplicate accounts. We will
                process refunds for duplicate charges. (Customer Success Team)
              </li>
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </>
  ),
});
